import { render, staticRenderFns } from "./OverviewReport.vue?vue&type=template&id=7a671f88&scoped=true"
import script from "./OverviewReport.vue?vue&type=script&lang=js"
export * from "./OverviewReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a671f88",
  null
  
)

export default component.exports